export default __webpack_public_path__ + "static/media/case-studies-3.08d388c2.jpg";